import { MenuGroup } from "../models/menus";
import { get } from "../repositories/participant";

export async function getMenus(
  planId: number,
  empId: number,
  role: string
): Promise<MenuGroup[]> {
  return get(`/plans/${planId}/employees/${empId}/menus`, { role });
}
